import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { useLang } from "@/lib/i18n-context";
import { Loader2, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ProtectedRoute({ children }) {
  const { user, loading, login } = useAuth();
  const { t } = useLang();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-brand-red animate-spin" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white border border-border rounded-2xl p-10 text-center shadow-sm">
          <div className="w-16 h-16 mx-auto rounded-full bg-brand-canvas flex items-center justify-center mb-4">
            <LogIn className="w-7 h-7 text-brand-red" />
          </div>
          <h2 className="font-display text-2xl font-bold mb-2">Sign in required</h2>
          <p className="text-sm text-muted-foreground mb-6">{t("login_required")}</p>
          <Button
            onClick={login}
            className="w-full h-11 rounded-full bg-brand-red hover:bg-brand-red-dark text-white"
            data-testid="protected-login-btn"
          >
            {t("login")}
          </Button>
          <p className="text-xs text-muted-foreground mt-4">{t("privacy_note")}</p>
        </div>
      </div>
    );
  }

  return children;
}
